var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_946_4174",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9773 12.2727H15V18.0682H23.0455C22.2955 21.75 19.1591 23.8636 15 23.8636C10.0909 23.8636 6.13636 19.9091 6.13636 15C6.13636 10.0909 10.0909 6.13636 15 6.13636C17.1136 6.13636 19.0227 6.88636 20.5227 8.11364L24.8864 3.75C22.2273 1.43182 18.8182 0 15 0C6.68182 0 0 6.68182 0 15C0 23.3182 6.68182 30 15 30C22.5 30 29.3182 24.5455 29.3182 15C29.3182 14.1136 29.1818 13.1591 28.9773 12.2727Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_946_4174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.36328 23.8636V6.13637L10.2276 15L-1.36328 23.8636Z",
    fill: "#FBBC05"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_946_4174",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9773 12.2727H15V18.0682H23.0455C22.2955 21.75 19.1591 23.8636 15 23.8636C10.0909 23.8636 6.13636 19.9091 6.13636 15C6.13636 10.0909 10.0909 6.13636 15 6.13636C17.1136 6.13636 19.0227 6.88636 20.5227 8.11364L24.8864 3.75C22.2273 1.43182 18.8182 0 15 0C6.68182 0 0 6.68182 0 15C0 23.3182 6.68182 30 15 30C22.5 30 29.3182 24.5455 29.3182 15C29.3182 14.1136 29.1818 13.1591 28.9773 12.2727Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_946_4174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.36328 6.13637L10.2276 15L15.0004 10.8409L31.364 8.18182V-1.36363H-1.36328V6.13637Z",
    fill: "#EA4335"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_946_4174",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9773 12.2727H15V18.0682H23.0455C22.2955 21.75 19.1591 23.8636 15 23.8636C10.0909 23.8636 6.13636 19.9091 6.13636 15C6.13636 10.0909 10.0909 6.13636 15 6.13636C17.1136 6.13636 19.0227 6.88636 20.5227 8.11364L24.8864 3.75C22.2273 1.43182 18.8182 0 15 0C6.68182 0 0 6.68182 0 15C0 23.3182 6.68182 30 15 30C22.5 30 29.3182 24.5455 29.3182 15C29.3182 14.1136 29.1818 13.1591 28.9773 12.2727Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_946_4174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.36328 23.8636L19.0913 8.18182L24.4776 8.86364L31.364 -1.36363V31.3636H-1.36328V23.8636Z",
    fill: "#34A853"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_946_4174",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9773 12.2727H15V18.0682H23.0455C22.2955 21.75 19.1591 23.8636 15 23.8636C10.0909 23.8636 6.13636 19.9091 6.13636 15C6.13636 10.0909 10.0909 6.13636 15 6.13636C17.1136 6.13636 19.0227 6.88636 20.5227 8.11364L24.8864 3.75C22.2273 1.43182 18.8182 0 15 0C6.68182 0 0 6.68182 0 15C0 23.3182 6.68182 30 15 30C22.5 30 29.3182 24.5455 29.3182 15C29.3182 14.1136 29.1818 13.1591 28.9773 12.2727Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_946_4174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3636 31.3636L10.2273 15L7.5 12.9545L31.3636 6.13637V31.3636Z",
    fill: "#4285F4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.ac6f835d12a0b4e7be33abc429baf3b2.svg";
export { ForwardRef as ReactComponent };